

const TRANSLATIONS_CS_CZ = {
    "email_otp.back":"Zpět",
    "email_otp.enter_email_text":"Níže zadejte svoji e-mailovou adresu, abychom vám mohli poslat unikátní kód",
    "email_otp.send_verification_link":"Zaslat ověřovací kód",
    "email_otp.resend_otp_with_timer":"Zaslat jednorázový kód za",
    "email_otp.text":"Zaslali jsme vám 6místný ověřovací kód na adresu [email]. Vepište kód níže",
    "email_otp.verify":"Ověřit",
    "reset_password.set_password":"Nastavte si heslo",
    "sign_in.or":"nebo",
    "sign_in.continue_with":"Nebo pokračujte prostřednictvím",
    "sign_in.continue_with_email":"Nebo pokračujte pomocí e-mailové adresy",
    "sign_in.create_without_password":"Vytvořte si účet bez hesla",
    "sign_in.create_with_otp":"Vytvořte si účet pomocí jednorázového přístupového kódu",
    "sign_in.login_with_otp":"Přihlaste se pomocí jednorázového přístupového kódu",
    "sign_in.login_without_password":"Přihlaste se bez hesla",
    "sign_in.tooltip_text":"Na e-mail vám pošleme unikátní jednorázový kód, abyste získali přístup do svého účtu.",
    "sign_up.tooltip_text":"Na e-mail vám pošleme unikátní jednorázový kód, abyste si mohli vytvořit účet.",
    "sign_in.password_updated":"Vaše heslo bylo aktualizováno.",
    "sign_up.create_an_account":"Vytvořte si účet",
    "email_otp.resend_otp":"Znovu zaslat jednorázové heslo",
    "sign_up.email_address":"E-mail",
    "sign_up.password":"Heslo",
    "sign_in.create_account": "Vytvořte si účet",
    "sign_in.title": "Přihlásit Se",
    "sign_in.forgot_password" : "Zapomněli jste heslo?",
    "reset_password.resend_email": "Znovu odeslat e-mail",
    "reset_password.sent_title": "E-mail byl odeslán!",
    "reset_password.rcvResetLink": "Zadejte vaši emailovou adresu níže zašleme vám odkaz na resetování vašeho hesla.",
    "reset_password.submit": "Pokračovat",
    "reset_password.back_to_login": "Zpět na přihlášení",
    "reset_password.create_new_password": "Vytvořte nové heslo pro přihlášení do Vašeho účtu.",
    "forgot_password.emailSent": "Pokud pro [] již existuje účet, pošleme vám e-mail s odkazem na obnovení hesla. Stále se nic nezobrazilo? Níže požádejte znovu o zaslání e-mailu.",
    "gdpr.continue": "Pokračovat",
    "validation.password_validation_heading": "Heslo musí obsahovat:",
    "validation.password_length_ui": "Nejméně 8 znaků",
    "validation.password_upper_case_ui": "Velké písmeno",
    "validation.password_lower_case_ui": "Malé písmeno",
    "validation.password_number_ui": "Číslici",
    "validation.password_symbol_ui": "Zvláštní znak",
    "form.gdprconsent": "Přihlášením potvrzujete, že jste si přečetli naše",
    "form.termsCondition": "smluvní podmínky a rozumíte jim.",
    "verify_otp.customer_service_center_link": "s/sluzby-zakaznikum",
    "activate_user.verification_successful.message": "Gratulujeme! Váš účet byl aktivován.",
    "activate_user.already_verified.message" : "Vítejte zpátky! Váš účet byl už ověřen.",

    // Errors Translations
    "sign_in.mandatory_field_error": "Než budete pokračovat, vyplňte všechna povinná pole.",
    "sign_in.invalid_email_error": "Zadejte e-mail ve správném formátu, např. jmeno@domena.cz",
    "sign_in.invalid_credentials_error": "Zadali jste neplatné uživatelské jméno nebo heslo. Zkuste to znovu.",
    "sign_in.generic_error": "Došlo k chybě. Zkuste to znovu.",
    "sign_in.account_unverified_error": "Váš účet ještě nebyl aktivován. Podívejte se do svého e-mailu, kde byste měli mít aktivační odkaz, nebo klikněte na „Zapomenuté heslo“ a nastavte si nový přístup k účtu.",
    "sign_in.max_attempt_error": "Dosáhli jste maximálního počtu pokusů. Zkuste to zase za nějakou dobu.",
    "sign_in.social_signin_error": "Přihlášení přes sociální síť (Google/facebook/apple). Zkuste to znovu nebo použijte jiný způsob přihlášení",
    "sign_in.social_signin_email_not_present_error": "Přihlášení se nezdařilo. Zkuste to znovu nebo použijte jinou možnost přihlášení.",
    "sign_in.guest_user_signin_error": "Vypadá to, že na tento e-mail už účet máte. Klikněte na „Forgot your password“ (Zapomenuté heslo) a nastavte přístupové údaje k vašemu účtu znovu.",
    
    "sign_up.mandatory_field_error": "Než budete pokračovat, vyplňte všechna povinná pole.",
    "sign_up.invalid_email_error": "Zadejte platnou e-mailovou adresu, například jmeno@domena.cz",
    "sign_up.password_length_error": "Heslo musí mít nejméně 8 znaků.",
    "sign_up.email_already_exist_error": "Tato e-mailová adresa již existuje. Použijte jinou e-mailovou adresu.",
    "sign_up.generic_error": "Došlo k chybě. Zkuste to znovu.",
    "sign_up.password_policy_error": "Heslo musí obsahovat: číslici, zvláštní znak [!#$%&'*+-/=?^_`{|}~.@], velká a malá písmena.",
    "sign_up.common_password_error": "Heslo se nesmí shodovat s vaší e-mailovou adresou",
    
    "forgot_password.mandatory_field_error": "Než budete pokračovat, vyplňte všechna povinná pole.",
    "forgot_password.invalid_email_error": "Zadejte e-mail ve správném formátu, např. jmeno@domena.cz",
    "forgot_password.generic_error": "Došlo k chybě. Zkuste to znovu.",
    
    "reset_password.mandatory_field_error": "Než budete pokračovat, vyplňte všechna povinná pole.",
    "reset_password.password_history_error": "Heslo se musí lišit od pěti předchozích hesel.",
    "reset_password.password_length_error": "Heslo musí mít nejméně 8 znaků.",
    "reset_password.password_policy_error": "Heslo musí obsahovat: číslici, zvláštní znak [!#$%&'*+-/=?^_`{|}~.@], velká a malá písmena.",
    "reset_password.common_password_error": "Heslo se nesmí shodovat s vaší e-mailovou adresou",
    "reset_password.generic_error": "Došlo k chybě. Zkuste to znovu.",
    
    "email_otp.email_required_error": "Jestli chcete pokračovat, zadejte svůj e-mail",
    "email_otp.invalid_email_error": "Zadejte platnou e-mailovou adresu, například jmeno@domena.cz",
    "email_otp.generic_error": "Došlo k chybě. Zkuste to zase za nějakou dobu",
    "email_otp.invalid_otp_error": "Zadané jednorázové heslo / ověřovací kód nefunguje. Zkuste to znovu.",
    "email_otp.resend_otp_error": "Nedaří se nám znovu zaslat jednorázové heslo. Zkuste to zase za nějakou dobu",
    "email_otp.verify_otp_error": "Došlo k chybě. Zkuste po nějaké době znovu ověření pomocí jednorázového hesla",
    "email_otp.verify_otp_limit_exceed_error": "Zadané jednorázové heslo je neplatné. Klikněte na „Zaslat nové jednorázové heslo“ a my vám ho pošleme",
    "email_otp.max_attempt_reached_error": "Dosáhli jste maximálního počtu pokusů. Zkuste to zase za nějakou dobu.",
    "email_otp.brute_force_error_part_1": "Zablokovali jsme dočasně váš účet, protože došlo k několika neúspěšným pokusům o přihlášení. Zkuste to znovu později nebo ",
    "email_otp.brute_force_error_part_2": "kontaktujte naše centrum nápovědy",
    "email_otp.brute_force_error_part_3": ", kde vám rádi pomůžeme.",

    //Page Titles
    "sign_in.page_title": "Přihlášení | Pens.com",
    "sign_up.page_title": "Přihlásit k odběru | Pens.com",
    "forgot-password.page_title": "Nepamatuji si své heslo | Pens.com",
    "reset-password.page_title": "Obnovit heslo | Pens.com",
    "sign-in.password_icon_aria_label_blured": "Blured Show password",
    "sign-in.password_icon_aria_label": "Show password",
    "sign-in.password_icon_aria_label_hidden": "Hide password",
    "sign-in.tooltip_icon_aria_label": "More Info",
    "email_otp.otp_digit_aria_label": "Please enter the code",
};
export default TRANSLATIONS_CS_CZ;